/* The shared dialog and disclosure behaviour that lived in app.js.

   showDialog() is defined per bundle (see the shim in v4-hub.js and friends);
   this handles closing, which the router used to own. */
(function () {
  var dialog = document.getElementById('proposal-dialog');

  if (dialog) {
    var close = dialog.querySelector('.dialog-close');
    if (close) {
      close.addEventListener('click', function () {
        dialog.close();
      });
    }
    // Clicking the backdrop closes it.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  }

  // EXPANDERS OPEN SLOWLY, NOT WITH A SNAP (Josh, 16 Sep). A native <details>
  // cannot animate its height in CSS alone, so the summary click is taken over:
  // opening animates from the summary's height to the full height, closing
  // runs it backwards and only then lets the browser close it. Once open, the
  // panel is eased into view if its bottom sits below the fold. The header's
  // menus (.sr-disclosure) are deliberately left alone.
  var ANIMATED = 'details.p-disclosure, details.p-full-specs, .p-answers details, details.p-fit-disclosure';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 320;

  function animateDetails(details, summary) {
    if (details.dataset.animating) return;
    var opening = !details.open;
    var from, to;
    details.dataset.animating = '1';
    details.style.overflow = 'hidden';
    if (opening) {
      from = summary.offsetHeight;
      details.open = true;
      to = details.scrollHeight;
    } else {
      from = details.offsetHeight;
      to = summary.offsetHeight;
    }
    var run = details.animate(
      [{ height: from + 'px' }, { height: to + 'px' }],
      { duration: DURATION, easing: 'cubic-bezier(.2,.7,.2,1)' }
    );
    run.onfinish = run.oncancel = function () {
      if (!opening) details.open = false;
      details.style.overflow = '';
      delete details.dataset.animating;
      if (opening) {
        var box = details.getBoundingClientRect();
        if (box.bottom > window.innerHeight) {
          details.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      }
    };
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || !details.matches(ANIMATED)) return;
    if (reduced || !details.animate) return; // let the browser snap it
    event.preventDefault();
    animateDetails(details, summary);
  });

  // Escape closes any open V4 disclosure and returns focus to its summary.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.sr-disclosure[open]').forEach(function (detail) {
      detail.open = false;
      var summary = detail.querySelector('summary');
      if (summary) summary.focus();
    });
  });

  // Clicking outside closes them too.
  document.addEventListener('click', function (event) {
    if (event.target.closest('.sr-disclosure')) return;
    document.querySelectorAll('.sr-disclosure[open]').forEach(function (detail) {
      detail.open = false;
    });
  });
})();
